/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_RoleInputs */

const vi_user_role = /** @type {(inputs: User_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai trò`)
};

/**

* @param {User_RoleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_role = /** @type {((inputs?: User_RoleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_RoleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_role(inputs)
});